<template>
  <el-row class="card" :style="cardStyle">
    <el-col v-loading="loading" class="card__content">

      <div class="card__subtitle" v-if="$slots.subtitle">
        <slot name="subtitle"></slot>
      </div>
      <div class="card__description" v-if="$slots.description">
        <slot name="description"></slot>
      </div>

      <el-collapse v-model="activeNames" class="collapse">
        <el-collapse-item :name="open ? 1 : 0" class="collapse__item">

          <template slot="title" class="collapse__header header">
            <div class="header__title">
              <slot name="title"></slot>
            </div>
            <div class="header__link">
              <slot name="link"></slot>
            </div>
          </template>

          <div class="collapse__content">
            <slot></slot>
          </div>

        </el-collapse-item>
      </el-collapse>

    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "BigCard",
  props: {
    width: {
      type: String,
      default: 'auto'
    },
    maxWidth: {
      type: String,
      default: '650px'
    },
    loading: {
      type: Boolean,
      default: false
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeNames: 1
    }
  },
  created() {

  },
  computed: {
    cardStyle() {
      return {
        width: this.width,
        maxWidth: this.maxWidth,
      }
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  margin: 25px 0;
  background: #fff;
  border: 0;
  padding: 5px;
  border-radius: 12px;

  &__content {
    min-height: 50px;
  }

  &__title {
    font-style: normal;

    margin-bottom: 12px;
    font-weight: 600;
    font-size: 20px;
    line-height: 26px;
    color: #111;
  }

  &__subtitle {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 13px;
    color: #111;
  }

  &__description {
    font-style: normal;
    font-weight: normal;
    font-size: 11px;
    line-height: 13px;
    color: #111;
    margin-top: 5px;
    margin-bottom: 22px;
  }
}


.collapse {
  border: none;
  border-radius: 12px;

  &__content {
    margin: 4px 48px;
  }

  > .collapse__item /deep/ > div > {

    .el-collapse-item__header {
      background: #fff;

      height: auto;
      border-bottom: none;

      &.is-active {
        border-bottom: 1px solid #eaeaea;
        transition: all 4s ease;

        .el-collapse-item__arrow {
          transform: rotate(180deg);

          &::before {
            content: "−";
            color: #43D3B3;
            font-size: 42px;
          }
        }
      }

      .el-collapse-item__arrow {
        margin: 0 35px 0 auto;

        &::before {
          content: "+";
          color: #43D3B3;
          font-size: 42px;
        }
      }
    }

    .el-collapse-item {
      border-radius: 50px;
      background: none;
    }

    .el-collapse-item__wrap {
      border-radius: 0 0  12px 12px;
      background: none;
      border: none;
    }
  }
}

.header {
  display: flex;
  align-items: center;

  &__title {
    margin: 27px 12px 27px 48px;

    font-weight: 600;
    font-size: 20px;
    line-height: 26px;
    color: #111;
  }

}
</style>
